// extracted by mini-css-extract-plugin
export default {"header":"ModalHeader_header__bZshL","title":"ModalHeader_title__YGIct","close":"ModalHeader_close__9tpT2"};